import React, { useCallback, useContext, useRef, useState } from 'react'
import { Modal, Button, Form, Col, Row, Container } from '@themesberg/react-bootstrap'
import { Context } from '../..'
import { upload } from '../../controller';

const _Popup = () => {

  const { state, dispatch } = useContext(Context);

  const _group = useRef(0)
  const _title = useRef('')
  const _subTitle = useRef('')
  const _subTitle2 = useRef('')
  const _image = useRef('')

  const handleClose = useCallback(() => {
    dispatch({
      type: 'CLOSE_ADD_POPUP',
      payload: {
        confirmed: false,
      },
    })
  }, [])

  const handleConfirm = useCallback(() => {
    if (_image.current) {
      dispatch({
        type: 'CLOSE_ADD_POPUP',
        payload: {
          confirmed: true,
          group: _group.current,
          image: _image.current,
          title: _title.current,
          subTitle: _subTitle.current,
          subTitle2: _subTitle2.current,
        },
      })
    } else {
      alert('Hãy up hình quảng cáo')
    }
  }, [])

  const onChangeGroup = useCallback((payload) => {
    _group.current = parseInt(payload.target.value);
  }, [])

  const onChangeTitle = useCallback((payload) => {
    _title.current = payload.target.value;
  }, [])

  const onChangeSubTitle = useCallback((payload) => {
    _subTitle.current = payload.target.value;
  }, [])

  const onChangeSubTitle2 = useCallback((payload) => {
    _subTitle2.current = payload.target.value;
  }, [])

  const uploadFunc = useCallback(async (file) => {
    _image.current = await upload(`${new Date().getTime()}`, 'banner', file)
    alert('Upload xong')
  }, [])

  const onImageChange = (evt) => {
    if (evt.target.files[0]) {
      uploadFunc(evt.target.files[0])
    }
  }

  return (
    <Modal as={Modal.Dialog} centered show={state.addPopup.show} size='xl'>
      <Modal.Header>
        <Modal.Title className="h6">Thêm quảng cáo</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Col>
            <Row className='p-1'>
              <Col sm={12} md={12}>
                <Row>
                  <Col md={3} className='text-left align-self-center'>
                    <Form.Label>Nhóm quảng cáo</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Form.Select onChange={onChangeGroup}>
                      <option defaultValue value={'0'}>Không có nhóm</option>
                      {state.listBannerGroup && state.listBannerGroup.map(i => {
                        return (<option value={`${i.id}`}>{i.title}</option>)
                      })}
                    </Form.Select>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className='p-1'>
              <Col sm={12} md={12}>
                <Row>
                  <Col md={3} className='text-left align-self-center'>
                    <Form.Label>Tiêu đề</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Form.Control onChange={onChangeTitle} required type="text" placeholder="Nhập tiêu đề" />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className='p-1'>
              <Col sm={12} md={12}>
                <Row>
                  <Col md={3} className='text-left align-self-center'>
                    <Form.Label>Phụ đề</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Form.Control onChange={onChangeSubTitle} required type="text" placeholder="Nhập phụ đề" />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className='p-1'>
              <Col sm={12} md={12}>
                <Row>
                  <Col md={3} className='text-left align-self-center'>
                    <Form.Label>Phụ đề 2</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Form.Control onChange={onChangeSubTitle2} required type="text" placeholder="Nhập phụ đề 2" />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Container>
        <Row>
          <Col md={12} className="mb-2">
            <Form.Group id="firstName">
              <Form.Label>Hình ảnh</Form.Label>
              <Form.Control placeholder='Hình ảnh' required type="file" onChange={onImageChange} />
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <div></div>
        <Button variant="secondary" className="ms-auto" onClick={handleConfirm}>
          Thêm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(_Popup)